import * as React from 'react';
import classnames from 'classnames';

import { abbrNum } from 'utils/helper/common';
import { renderPrice } from 'utils/helper/price';
import { t } from 'utils/language';

type Props = {
  title: string,
  budget?: number,
  followers?: number,
  count?: number,
  variablePayments?: number,
  display?: string,
  showOnlyBudget?: boolean,
  showOnlyVariablePayments?: boolean,
  showNotApplicable?: boolean
};

type CampaignSummaryGroupColumnProps = {
  label: string,
  value: string | number
};

const CampaignSummaryGroupColumn = ({
  label,
  value
}: CampaignSummaryGroupColumnProps) => (
  <div className="campaign-summary-group__value">
    <span
      className="campaign-summary-group__item campaign-summary-group__item--font-size-normal text-overflow-ellipsis"
      title={String(value)}
    >
      {value}
    </span>
    <span className="campaign-summary-group__item">{label}</span>
  </div>
);

const CampaignSummaryGroup = (
  {
    budget,
    followers,
    variablePayments,
    count,
    title,
    display,
    showOnlyBudget,
    showOnlyVariablePayments,
    showNotApplicable
  }: Props
): JSX.Element => {
  const classes = classnames({
    'campaign-summary-group__box': true,
    [`campaign-summary-group__box--display-${display || ''}`]: display
  });
  const titleClasses = classnames({
    'campaign-summary-group__box-title': true
  });
  const budgetValue = (showNotApplicable && (!budget || budget < 0)) ?
    t('campaign_summary_budget_not_applicable') :
    renderPrice(budget || 0);

  if (showOnlyBudget) {
    return (
      <div className={classes}>
        <h3 className={titleClasses}>{title}</h3>
        <div className="campaign-summary-group__values">
          <div className="campaign-summary-group__value">
            <span
              className="campaign-summary-group__item campaign-summary-group__item--font-size-large text-overflow-ellipsis"
              title={budgetValue}
            >
              {budgetValue}
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (showOnlyVariablePayments) {
    return (
      <div className={classes}>
        <h3 className={titleClasses}>{title}</h3>
        <div className="campaign-summary-group__values">
          <CampaignSummaryGroupColumn
            label={t('campaign_summary_payment')}
            value={renderPrice(variablePayments || 0)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={classes}>
      <h3 className={titleClasses}>{title}</h3>
      <div className="campaign-summary-group__values">
        <CampaignSummaryGroupColumn
          label={t('campaign_summary_budget')}
          value={budgetValue}
        />
        <CampaignSummaryGroupColumn
          label={t('campaign_summary_followers')}
          value={abbrNum(followers, { decimal: 1 })}
        />
        <CampaignSummaryGroupColumn
          label={t('campaign_summary_creators')}
          value={count || 0}
        />
      </div>
    </div>
  );
};

CampaignSummaryGroup.defaultProps = {
  showOnlyBudget: false
};

export default CampaignSummaryGroup;
